import React, {createContext, useContext, useEffect} from "react";
import {observer} from "mobx-react";
import {StoreContext} from "../../store.context";

interface AuthContextValues {
    isAuthenticated: boolean;
    logout: () => void;
}

const defaultAuthContextValues: AuthContextValues = {
    isAuthenticated: false,
    logout: () => {}
};

export const AuthContext = createContext<AuthContextValues>(
    defaultAuthContextValues
);

interface AuthContextProviderProps {
    children: React.JSX.Element;
}

const KeycloakAuthenticationProvider = observer((props: AuthContextProviderProps) => {
    const {
        appStore: {
            authStore: {
                authenticated,
                login,
                logout,
            }
        }
    } = useContext(StoreContext);

    useEffect(() => {
        if (!authenticated) { login(); }
    }, [authenticated, login]);

    return (
        <AuthContext.Provider value={{ isAuthenticated: authenticated, logout }}>
            {props.children}
        </AuthContext.Provider>
    );
});

export default KeycloakAuthenticationProvider;